import { VALID_EMAIL_HASH } from 'libs/utils/validation/validation';

export const normalizeLink = (_link: string) => {
    if (!_link) {
        return _link;
    }

    const link = _link.trim();
    const linkLowerCase = link.toLowerCase();
    if (
        linkLowerCase.startsWith('http://') ||
        linkLowerCase.startsWith('https://') ||
        linkLowerCase.startsWith('mailto:')
    ) {
        return link;
    }
    if (link.match(VALID_EMAIL_HASH)) {
        return `mailto:${link}`;
    }
    return `https://${link}`;
};
